
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
var tpLoadingSite = (function () {
  return {
    init: function () {
      this.handLoading();
    },
    handLoading: function () {
      document.addEventListener("DOMContentLoaded", function () {
        const tpLoading = document.querySelector('.tp-loading-site');
        if (!tpLoading) return;
        document.querySelector('html').classList.remove('tp-over-flow-hidden');
        tpLoading.style.display = 'none';
      });
    }
  }
})()
tpLoadingSite.init();
window.getCookie = function (cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
window.setCookie = function (cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

window.trapFocus = function (container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  window.removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

window.pauseAllMedia = function () {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

window.removeTrapFocus = function (elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
    this.updateStickyAddToCart();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    this.updateStickyAddToCart();
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }

  updateStickyAddToCart() {
    //custom Quantity Sticky Add To Cart
    const tpStickyAddToCart = document.querySelector('sticky-product-detail');
    if (!tpStickyAddToCart) return;
    const inputStickyAddToCart = tpStickyAddToCart?.querySelector('.input-quantity-sticky');
    inputStickyAddToCart.value = parseInt(this.input.value);
  }
}

customElements.define('quantity-input', QuantityInput);

window.debounce = function (fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

window.fetchConfig = function (type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');

    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      window.trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    window.trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    window.removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    window.removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          window.trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    window.trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    window.trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    window.removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);
class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  onVariantChange(event) {
    this.updateCheckedLabel(event)
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses(event);
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      // this.setUnavailable();
    } else {
      this.updateMedia(event);// update image
      this.updateURL(event);
      this.updateVariantInput();
      this.updateVariant(this.currentVariant.id);
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateCheckedLabel(e) {
    const el = e.target;
    el.closest('fieldset').querySelectorAll('.variants-item').forEach(function (item) {
      if (item.getAttribute('checked') == 'true') {
        item.setAttribute('checked', 'false')
      }
    })
    el.setAttribute('checked', 'true')
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateImage(data_img) {
    //use product item
    const prd_item = this.closest('.tp-prd-item');
    if (prd_item) {

      const img_variant_prd_item = prd_item.querySelector('.tp__responsive-image img');
      let srcSetImgVariant = data_img + ' 165w, '
        + data_img + ' 330w' + ', '
        + data_img + ' 535w' + ', '
        + data_img + ' 750w' + ', '
        + data_img + ' 1000w' + ', '
        + data_img + ' 1500w' + ', '
        + data_img + ' 3000w ';
      img_variant_prd_item.setAttribute('srcset', srcSetImgVariant);
      img_variant_prd_item.setAttribute('src', data_img);

    }
  }
  updateMedia(e) {
    //page main produt (product detail)
    const el = e.target;
    const swiperMainPrd = document.querySelector('.swiper-main-prd');
    if (!this.currentVariant || !this.currentVariant.featured_media || !swiperMainPrd) return;

    var featured_media_id = this.currentVariant.featured_media.id;
    var position = el.closest('.tp-main-prd').querySelector(`.swiper-main-prd [data-id-media="${featured_media_id}"]`).getAttribute('data-position');
    window.productThumb?.slideTo((position - 1), 0);
    window.productMain.slideTo((position - 1), 0);
  }
  updateVariant(dataVariant) {
    if (!dataVariant) return;
    const parentPrd = this.closest('.product--parent');
    const id_variant = parentPrd.querySelector('.product-variant-id');
    if (id_variant) id_variant.value = dataVariant;
  }
  updateURL(event) {
    const el = event.target;
    const mainProductDetail = el.closest('.tp-main-prd');
    if (!mainProductDetail) return;
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector('label[checked="true"]').dataset.value === variant.option1
    );
    const labelWrappers = [...this.querySelectorAll('.product-form__input')];
    labelWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('.data-variant-js, option')];

      const previousOptionSelected = labelWrappers[index - 1].querySelector('label[checked="true"]').dataset.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    // if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    //render image
    const data_img = this.currentVariant.featured_media
    const src_img = data_img?.preview_image.src
    this.updateImage(src_img)
    //render price
    const price = this.currentVariant.price;
    const priceCompare = this.currentVariant.compare_at_price;
    this.renderPrice(price, priceCompare);

    //default dawn
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
    //end default dawn

  }
  renderPrice(price, priceCompare, stickyDetail, el) {
    var parentNode = this.closest('.product--parent');
    if (stickyDetail) {
      //use sticky add to cart page product detail
      var parentNode = document.querySelector('.sticky-product-detail');
      var elParentPrice = parentNode.querySelector('.stick__info--title-price');
    } else if (el) {
      // use upsell bundle
      var parentNode = el.closest('.product--parent');
      const sectionId = el.dataset.section;
      const productId = el.dataset.product;
      var elParentPrice = parentNode.querySelector(`#price-${sectionId}-${productId}`);
    } else {
      const sectionId = this.dataset.section;
      const productId = this.dataset.product;
      var elParentPrice = parentNode.querySelector(`#price-${sectionId}-${productId}`);
    }
    if (!elParentPrice) return;
    const price__regular = elParentPrice.querySelector('.price__regular');
    const price__sale = elParentPrice.querySelector('.price__sale');
    if (priceCompare != null && priceCompare != "") {
      price__sale.style.display = 'block'
      price__regular.style.display = 'none'
      const priceLast = price__sale.querySelector('.price-item--last');
      const priceSale = price__sale.querySelector('.price-item--regular');
      priceLast.textContent = this.formatCurrency(price);
      priceSale.textContent = this.formatCurrency(priceCompare);
    } else {
      price__sale.style.display = 'none'
      price__regular.style.display = 'block'
      price__regular.querySelector('.price-item--regular').textContent = this.formatCurrency(price);
    }

  }
  formatCurrency(price) {
    if (price > 0) {
      const priceInDollars = price / 100; // Convert cents to dollars
      const formattedPrice = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.currencyStrings.iso_code,
        minimumFractionDigits: 2
      }).format(priceInDollars);

      return formattedPrice;
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

//Initializes the object used for the file upsell-product-bundle.js
window.handlePriceUpsellBundle = new VariantSelects();

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.querySelectorAll('label').forEach(
      (button) => button.addEventListener('click', this.onVariantChange.bind(this), false)
    );
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {

    listOfOptions.forEach((label) => {
      if (listOfAvailableOptions.includes(label.getAttribute('data-value'))) {
        label.classList.remove('disabled');
      } else {
        label.classList.add('disabled');
      }
    });
  }
  updateOptions() {
    this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
    let arrRadioCheckedValue = [];
    this.fieldsets.forEach(function (fieldset) {
      fieldset.querySelectorAll(".data-variant-js").forEach(function (label) {
        const is_checked = label.getAttribute('checked')
        if (is_checked == 'true') {
          arrRadioCheckedValue.push(label.dataset.value);
        }
      });
    });
    this.options = arrRadioCheckedValue;
  }
}
customElements.define('variant-radios', VariantRadios);


class VariantImageProductItem extends VariantSelects {
  constructor() {
    super();
    this.querySelectorAll('.image-variant-item').forEach(
      (button) => button.addEventListener('click', this.onVariantChangeImage.bind(this), false)
    );
  }
  onVariantChangeImage(e) {
    const target = e.target;
    const data_img = target.dataset.src;
    const data_index = target.dataset.index;
    const price = target.dataset.price;
    const dataVariant = target.dataset.idVariant;
    const priceCompare = target.dataset.priceCompare;
    // setTimeout(() => {
    this.updateImage(data_img);
    // }, 1500);

    this.updateMedia(data_index);
    this.activeImageVariant(target);
    this.renderPrice(price, priceCompare);
    this.updateVariant(dataVariant);
  };
  activeImageVariant(target) {
    const parent = target.parentNode;
    let imageVariantItemActive = target.closest("variant-image-product-item").querySelector(".image-variant-item.active");
    if (!target.classList.contains("active") && imageVariantItemActive) {
      target.classList.add("active");
      imageVariantItemActive.classList.remove("active");
    }
    parent.querySelector('span').classList.add('flex');
    parent.querySelector('span').classList.remove('hidden');
    // setTimeout(() => {
    parent.querySelector('span').classList.remove('flex');
    parent.querySelector('span').classList.add('hidden');
    // }, 1500);
  };
  updateMedia(data_index) {
    const swiperMainPrd = document.querySelector('.swiper-main-prd');
    if (!swiperMainPrd) return;
    const slide = swiperMainPrd.querySelector(`[data-position="${data_index}"]`);
    if (!slide) return;
    const slides = Array.from(swiperMainPrd.querySelectorAll('[data-position]'));
    const realIndex = slides.indexOf(slide);
    if (realIndex === -1) return;
    window.productThumb?.slideTo(realIndex, 0);
    window.productMain.slideTo(realIndex, 0);
  }
  updateVariant(dataVariant) {
    if (!dataVariant) return;
    const parentPrd = this.closest('.product--parent');
    const id_variant = parentPrd.querySelector('.product-variant-id');
    id_variant.value = dataVariant;
  }
}
customElements.define("variant-image-product-item", VariantImageProductItem);

class VariantDropdownSelects extends VariantSelects {
  constructor() {
    super();
    this.querySelectorAll('.select-variant-item').forEach(
      (button) => button.addEventListener('change', this.onVariantChange.bind(this), false)
    );
  }

  onVariantChange(event) {
    this.updateCheckedLabel(event)
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    // this.updateVariantStatuses(event);
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      // this.setUnavailable();
    } else {
      this.updateMedia(event);// update image
      this.updateURL(event);
      this.updateVariantInput();
      this.updateVariant(this.currentVariant.id);
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateCheckedLabel(e) {
    const el = e.target;
    el.closest('.product-form__input--dropdown').querySelectorAll('.variants-item').forEach(function (item) {
      if (item.getAttribute('checked') == 'true') {
        item.setAttribute('checked', 'false')
      }
    })
    el.setAttribute('checked', 'true')
  }
}

customElements.define('variant-dropdown', VariantDropdownSelects);




var prdItemSelectOption = (function () {
  return {
    init: function () {
      this.select_option();
    },
    select_option: function () {
      // select option
      document.addEventListener('click', function (e) {
        if (e.target.classList.contains('select-option__btn')) {
          e.target.closest('.select-option').classList.add('active')
          e.target.classList.add('hidden')
          const content = e.target.parentNode.querySelector('.select-option__content')

          if (content.style.maxHeight) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + 'px';
          }

          const hoverImage = e.target.closest('.card__inner').querySelector('.hover-img')
          const productItemAction = e.target.closest('.card__inner').querySelector('.bottom')
          if (hoverImage) {
            hoverImage.style.opacity = 0
          }
          if (productItemAction) {
            productItemAction.classList.add('hidden')
          }
        }
        if (!e.target.classList.contains('select-option__btn') && !e.target.classList.contains('select-option__content') && !e.target.closest('.select-option__content')) {
          const selectOptionContent = document.querySelectorAll('.select-option__content')
          if (selectOptionContent.length > 0) {
            selectOptionContent.forEach(function (item) {
              item.style.maxHeight = null;
              item.parentNode.querySelector('.select-option__btn').classList.remove('hidden')
              item.closest('.select-option').classList.remove('active')
            })
          }
        }
      })
    },
  };
})();
prdItemSelectOption.init();


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
          const tpPrdRecom = document.querySelector('.js-tp-prd-recom');
          const spaceBetween = Number(tpPrdRecom.dataset.spaceBetween);
          const slidesPerView = Number(tpPrdRecom.dataset.desktop);
          const loop = tpPrdRecom.dataset.loop === "true";
          const autoplay = tpPrdRecom.dataset.autoplay === "true";
          var swpPrdRecom = new Swiper(".js-tp-prd-recom", {
            spaceBetween: 15,
            slidesPerView: 1.5,
            slidesPerGroup: 1.5,
            loop: loop,
            autoplay: autoplay,
            freeMode: true,
            watchSlidesProgress: true,
            navigation: {
              nextEl: ".swiper-next-prd-recom",
              prevEl: ".swiper-prev-prd-recom",
            },
            pagination: {
              clickable: true,
              el: ".swiper-pagination-prd-recom",
            },
            breakpoints: {
              410: {
                slidesPerView: 2,
                slidesPerGroup: 2,
              },
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
              },
              1025: {
                slidesPerView: slidesPerView,
                slidesPerGroup: slidesPerView,
                spaceBetween: spaceBetween
              }

            },
          });
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


var tpLazyloadImg = (function () {
  return {
    init: function () {
      this.lazyReady();
    },
    lazyReady: function () {
      if (!!window.IntersectionObserver) {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.width = entry.boundingClientRect.width;
                entry.target.height = entry.boundingClientRect.height;
                entry.target.sizes = `${entry.boundingClientRect.width}px`;
                entry.target.classList.add("tp-loaded-image");
                entry.target
                  .closest(".tp-image-js")
                  .classList.remove("tp-loading-image");
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: "10px" }
        );
        document.querySelectorAll(".tp-image-js img").forEach((img) => {
          observer.observe(img);
        });
      }
    },
  };
})();
tpLazyloadImg.init();


var tpCollabsFooter = (function () {
  return {
    init: function () {
      this.clickCollab();
    },
    clickCollab: function () {
      const titleFooter = document.querySelectorAll('.footer__heading');
      if (titleFooter.length = 0) return;
      titleFooter.forEach(function (item) {
        item.addEventListener('click', function () {
          // change svg
          if (this.querySelector('span').classList.contains('icon-toggle')) {
            this.querySelector('span').classList.toggle('active');
          }
          // open close content
          let subMenuFooter = item.parentNode.querySelector('.footer__menu');
          if (subMenuFooter.style.maxHeight) {
            subMenuFooter.style.maxHeight = null;
          } else {
            subMenuFooter.style.maxHeight = subMenuFooter.scrollHeight + 'px';
          }
        });
      });
    }
  }
})()
tpCollabsFooter.init();

//------Custom animation sumary------//

class AnimationSummary {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('.content-animation');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }
  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight]
    }, {
      duration: 400,
      easing: 'ease-out'
    });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}
document.querySelectorAll('details').forEach((el) => {
  new AnimationSummary(el);
});


window.showNotifications = function (mess) {
  var x = document.querySelector("#snackbar");

  if (x) {
    if (x.classList.contains('show')) {
      x.classList.remove('show')
    }

    x.classList.add('show')
    x.innerHTML = mess

    setTimeout(function () {
      x.classList.remove('show')
    }, 3000);
  }
}

window.hideNotifications = function () {
  var x = document.querySelector("#snackbar");
  if (x && x.classList.contains('show')) {
    x.classList.remove('show')
  }
}


class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        window.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton?.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton?.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton?.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.collectionSearch = document.querySelector('.tp-clc-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
    this.collectionSearch.classList.add('hidden');
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);

class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

const tpSearch = (function () {
  return {
    inint: function () {
      this.toggleSearch();
    },
    toggleSearch: function () {
      window.addEventListener('click', function (e) {
        const el = e.target;
        const contentWrapper = el.closest('.header__search');
        if (!contentWrapper) return;
        const content = contentWrapper.querySelector('.search-modal--wrapper');

        const html = document.querySelector('html');
        const tpOverlaySearch = contentWrapper.querySelector('.tp-overlay-search');
        if (el.classList.contains('modal-search-toggle-open')) {
          openPopup(content, tpOverlaySearch, html)
        }
        if (el.classList.contains('modal-search-toggle-close') || el == tpOverlaySearch) {
          closePopup(content, tpOverlaySearch, html)
        }

      })
      function openPopup(contentWrapper, tpOverlaySearch, html) {
        contentWrapper.classList.remove('hidden');
        contentWrapper.classList.add('animation-search');
        tpOverlaySearch.classList.add('is-visible-search');
        html.classList.add('tp-over-flow-search-hidden');
      }
      function closePopup(content, tpOverlaySearch, html) {
        content.classList.add('hidden');
        tpOverlaySearch.classList.remove('is-visible-search');
        html.classList.remove('tp-over-flow-search-hidden');
      }
    }
  }
})();
tpSearch.inint();

window.tpCountdownTimer = (function () {
  return {
    init: function () {
      this.eventCountDownTimer();
      this.handleCountdown();
    },

    eventCountDownTimer: function () {
      const element = document.querySelectorAll(".tp-countdown-timer");
      if (element.length === 0) return;
      element.forEach((e) => {
        const text = e.getAttribute("data-text");
        const day = e.getAttribute("data-days");
        const hrs = e.getAttribute("data-hrs");
        const secs = e.getAttribute("data-secs");
        const mins = e.getAttribute("data-mins");
        const time = e.getAttribute("data-time");
        var countDownDate = new Date(time).getTime();
        var timer = setInterval(function () {
          var now = new Date().getTime();
          var distance = countDownDate - now;
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if (days < 10) {
            var days = days.toString().padStart(2, "0")
          }
          if (hours < 10) {
            var hours = hours.toString().padStart(2, "0")
          }
          if (minutes < 10) {
            var minutes = minutes.toString().padStart(2, "0")
          }
          if (seconds < 10) {
            var seconds = seconds.toString().padStart(2, "0")
          }
          var html =
            '<span class="countdown-text"><span class="countdown-ti countdown-label">' +
            text +
            "</span> " +
            '<span class="countdown-days cd-item inline-flex"><span class="countdown-ti">' +
            days +
            '</span> <span class="countdown-tx">' +
            day +
            "</span></span> " +
            '<span class="countdown-hours cd-item inline-flex"><span class="countdown-ti">' +
            hours +
            '</span> <span class="countdown-tx">' +
            hrs +
            "</span></span> " +
            '<span class="countdown-min cd-item inline-flex"><span class="countdown-ti">' +
            minutes +
            '</span> <span class="countdown-tx">' +
            mins +
            "</span></span> " +
            '<span class="countdown-sec cd-item inline-flex"><span class="countdown-ti">' +
            seconds
            +
            '</span> <span class="countdown-tx">' +
            secs +
            "</span></span>";
          e.querySelector(".tp-product-countdown").innerHTML = html;
          if (distance < 0) {
            clearInterval(timer);
          }
        }, 1000);
      });
    },
    handleCountdown: function () {
      var second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;
      const timer = document.querySelectorAll(".art__timer");
      timer.forEach((e) => {
        const { timer } = e?.dataset;
        var countDown = new Date(timer).getTime();
        if (countDown) {
          setInterval(function () {
            var now = new Date().getTime(),
              distance = countDown - now;
            if (countDown >= now) {
              (e.querySelector(".js-timer-days").innerText =
                Math.floor(distance / day) < 10
                  ? ("0" + Math.floor(distance / day)).slice(-2)
                  : Math.floor(distance / day)),
                (e.querySelector(".js-timer-hours").innerText = (
                  "0" + Math.floor((distance % day) / hour)
                ).slice(-2)),
                (e.querySelector(".js-timer-minutes").innerText = (
                  "0" + Math.floor((distance % hour) / minute)
                ).slice(-2)),
                (e.querySelector(".js-timer-seconds").innerText = (
                  "0" + Math.floor((distance % minute) / second)
                ).slice(-2));
            }
          }, second);
        }
      });
    },
  };
})();

window.tpCountdownTimer.init();

const swiperBanner = (function () {
  return {
    init: function () {
      this.handleSwiperBanner();
    },
    handleSwiperBanner: function () {
      var productBanner = new Swiper('.tp-product__banner', {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: true,
        loop: true,
        navigation: {
          nextEl: ".swiper-next-prd-list",
          prevEl: ".swiper-prev-prd-list",
        },
        breakpoints: {
          410: {
            slidesPerView: 2,
            spaceBetween: 30,
          }
        },
      });
    }
  }
})()
swiperBanner.init();
function mobileStickyBar() {
  const stickybar = document.querySelector('.tp-mobile-stickybar');
  if (!stickybar) {
    return;
  }
  const currentScroll = window.pageYOffset;
  let headerbar = 0;
  if (document.querySelector('.announcement-bar')) {
    headerbar = document.querySelector('.announcement-bar').clientHeight;
  }
  let headertopbar = 0;
  if (document.querySelector('.tp__top-bar')) {
    headertopbar = document.querySelector('.tp__top-bar').clientHeight;
  }
  let headerpage = document.querySelector('.tp-header').clientHeight;
  let headerh = headerbar + headertopbar + headerpage + 50;
  if (currentScroll > headerh) {
    stickybar.classList.remove('hidden');
  } else {
    stickybar.classList.add('hidden');
  }
  if (innerWidth < 768) {
    const footerbar = document.querySelector('.section-footer-padding');
    if (footerbar) {
      footerbar.style.paddingBottom = 60 + 'px';
    }
  }
}

var btnBackToTop = document.getElementById("backToTop");
if (document.getElementById("backToTop")) {
  window.scrollFunction = function () {
    const isScrolled = document.body.scrollTop > 20 || document.documentElement.scrollTop > 20;
    btnBackToTop.style.opacity = isScrolled ? 1 : 0;
  }
  // When the user clicks on the button, scroll to the top of the document
  btnBackToTop.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
}

window.onscroll = function () {
  mobileStickyBar();
  if (btnBackToTop) {
    window.scrollFunction();
  }
};
const notifiBrowser = (function () {
  return {
    init: function () {
      this.handleNotifiBrowser();
    },
    handleNotifiBrowser: function () {
      // Change document title when change tab in brower
      if (!window.flashingBrowseTab.enable === 'true') return;
      let siteTitleDefault = '';
      siteTitleDefault = document.title;
      let reminderText1 = window.flashingBrowseTab.firstNotification;
      let reminderText2 = window.flashingBrowseTab.secondaryNotification;

      let arrReminder = []
      if (reminderText1) {
        arrReminder.push(reminderText1)
      }
      if (reminderText2) {
        arrReminder.push(reminderText2)
      } else {
        arrReminder.push(siteTitleDefault)
      }
      let point = 0;
      function changeReminderTitle() {
        document.title = arrReminder[point]

        if (point < arrReminder.length - 1) {
          point++;
        } else {
          point = 0
        }

        window.changeReminderTitleTimeout = setTimeout(() => {
          changeReminderTitle()
        }, 3000)
      }

      window.addEventListener('blur', () => {
        if (reminderText1.length === 0 && reminderText2.length === 0) {
          document.title = siteTitleDefault
        } else {
          changeReminderTitle()
        }

      });

      window.addEventListener('focus', () => {
        clearTimeout(window.changeReminderTitleTimeout)
        document.title = siteTitleDefault;
      });

    }
  }
})()
notifiBrowser.init()

var tpColorSwatchesShopify = (function () {
  return {
    init: function () {
      this.initSwatches();
    },
    initSwatches: function () {
      const _this = this;
      const actionSwatchColor = document.querySelectorAll(
        ".tp__product-color-swatches"
      );
      const actionSwatch = document.querySelectorAll(".tp__option-swatch-js");
      actionSwatch.forEach((e) => {
        const productTarget = e.closest(".tp-prd-item");
        if (productTarget) {
          e.addEventListener("mouseover", () => {
            _this.listenerColor(e, productTarget);
          });
        }
      });
    },

    listenerColor: function (e, productTarget) {
      const _this = this;
      setTimeout(() => {
        if (!e.classList.contains("active")) {
          const activeSwatches = e
            .closest(".tp__product-option")
            .querySelectorAll(".tp__option-swatch-js");
          activeSwatches.forEach((el) => {
            el.classList.remove("active");
          });
          e.classList.toggle("active");
          _this.swapProduct(productTarget);
        }
      }, 0);
    },

    updateMasterId(options, variantData) {
      var result = variantData.find((variant) => {
        return !variant.options
          .map((option, index) => {
            return options[index] === option;
          })
          .includes(false);
      });
      return result;
    },

    updatePrice(currentVariant, productTarget) {
      const _this = this;
      if (!currentVariant) return;
      const compare_at_price = currentVariant.compare_at_price;
      const price = currentVariant.price;
      const price__regular = productTarget.querySelector('.price__regular');
      const price__sale = productTarget.querySelector('.price__sale');
      if (compare_at_price != null && compare_at_price != "") {
        price__sale.style.display = 'block'
        price__regular.style.display = 'none'
        const priceLast = price__sale.querySelector('.price-item--last');
        const priceSale = price__sale.querySelector('.price-item--regular');
        priceLast.textContent = _this.formatCurrency(price);
        priceSale.textContent = _this.formatCurrency(compare_at_price);
      } else {
        price__sale.style.display = 'none'
        price__regular.style.display = 'block'
        price__regular.querySelector('.price-item--regular').textContent = this.formatCurrency(price);
      }
    },
    formatCurrency(price) {
      if (price > 0) {
        price = price.toString();
        let firstPrice = price.substr(0, price.length - 2);
        let stringResult = new Intl.NumberFormat().format(parseInt(firstPrice));
        stringResult = stringResult.replace(".", ",");
        const currency_code_enabled = window.currencyStrings.currency_code
        if (currency_code_enabled == 'true') {
          return window.currencyStrings.symbol + stringResult + '.00' + ' ' + window.currencyStrings.iso_code;
        } else {
          return window.currencyStrings.symbol + stringResult + '.00'
        }
      }
    },
    updateMedia(currentVariant, productTarget) {
      if (!currentVariant) return;
      if (!currentVariant.featured_media) return;
      setTimeout(() => {
        productTarget
          .querySelector(".tp__responsive-image img")
          .removeAttribute("srcset");
        productTarget
          .querySelector(".tp__responsive-image img")
          .setAttribute("src", currentVariant.featured_media.preview_image.src);
      }, 200);
    },

    renderProductInfo(currentVariant, productTarget) {
      const variantIdForm = productTarget.querySelector('.product-variant-id');
      variantIdForm.value = currentVariant.id
    },

    swapProduct: function (productTarget) {
      const product_swatch_active = productTarget.querySelector(
        ".tp__option-swatch-js.active"
      );
      const position_swatch =
        product_swatch_active.getAttribute("data-position");
      const variantData = JSON.parse(
        productTarget.querySelector(".productinfo").textContent
      );

      let options = Array.from(
        productTarget.querySelectorAll(".tp__option-swatch-js.active"),
        (select) => select.getAttribute("data-value")
      );
      variantData.find((variant) => {
        if (options.length == 1) {
          const variantOptions = {
            1: variant.option1,
            2: variant.option2,
            3: variant.option3,
          };
          if (variantOptions[position_swatch] === options[0]) {
            options = variant.options;
          }
        }
      });
      const currentVariant = this.updateMasterId(options, variantData);
      this.updatePrice(currentVariant, productTarget);
      this.updateMedia(currentVariant, productTarget);
      this.renderProductInfo(currentVariant, productTarget, product_swatch_active.dataset.color);
    },
  };
})();
tpColorSwatchesShopify.init();

localStorage.setItem('scrollPosition', window.scrollY);
window.onpopstate = function () {
  const scrollPosition = localStorage.getItem('scrollPosition');
  window.scrollTo(0, scrollPosition);

};











